import FormDatetime from "components/shared/form/datetime";
import React from "react";

export default class Datetime extends FormDatetime {
    render() {
        return (
            <>
                {this.renderField()}
                {this.renderError()}
            </>
        );
    }
}
